export default __webpack_public_path__ + "static/IBMPlexSans-Text-Latin1-587bb1d61dad93cea0dd00ad5a9aabde.woff";